import PRC from "components/Stacker/constants/ProductConfiguratorConstants"

export const prevStep = () => {
  return {
    type: PRC.PRODUCT_CONFIG_PREV_STEP,
  }
}
export const nextStep = () => {
  return {
    type: PRC.PRODUCT_CONFIG_NEXT_STEP,
  }
}
export const setMetal = (data) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_METAL,
    payload: data,
  }
}
export const setDesign = (data) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_DESIGN,
    payload: data,
  }
}
export const setCustom = (data) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_CUSTOM,
    payload: data,
  }
}
export const setMotif = (data) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_MOTIF,
    payload: data,
  }
}
export const setTheme = (data) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_THEME,
    payload: data,
  }
}
export const resetPRC = () => {
  return {
    type: PRC.PRODUCT_CONFIG_RESET,
  }
}
export const setConfigData = (args) => {
  return {
    type: PRC.PRODUCT_CONFIG_SET_CONFIG_DATA,
    payload: args,
  }
}
